import { render } from "./DocContextMenu.vue?vue&type=template&id=339ded8d"
import script from "./DocContextMenu.vue?vue&type=script&lang=js"
export * from "./DocContextMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__